import styled from "styled-components";

export const SuggesticLinkWrapper = styled.a`
  display: flex;
  margin: 20px 0;
  position: relative;
  z-index: 2;
`